module.exports = "/static/assets/df28596aead9efac5480b1f106abdba3.gif";